module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticStyle: {
      "margin": "50px auto",
      "width": "600px",
      "height": "357px",
      "font-size": "22px",
      "line-height": "100px"
    }
  }, [_vm._v("温馨提示：正在跳转为开心互联支付网关，请您稍等...\n  ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b69e5462"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/member-center/right/pay.vue
// module id = 1661
// module chunks = 1